// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './main.css'
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  created() {
    window.onresize = function (e) {
      let designSize = 1920;
      let wW = document.documentElement.clientWidth;
      let hH = document.documentElement.clientHeight;
      if (wW >= 1140) {
        let rem = wW * 100 / designSize;
        document.documentElement.style.fontSize = rem + 'px';
        document.documentElement.id = ""
      } else {
        document.documentElement.id = "maxPage"
      }
    }
    window.onload = function () {
      let designSize = 1920;
      let wW = document.documentElement.clientWidth;
      if (wW >= 1140) {
        let rem = wW * 100 / designSize;
        document.documentElement.style.fontSize = rem + 'px';
      } else {
        let rem = 1140 * 100 / designSize;
        document.documentElement.style.fontSize = rem + 'px';
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js